import axios from 'axios'
import Cookies from 'js-cookie'
import store from '@/store'

class TravelApi {
    api () {
        const APP_ENV = process.env.NODE_ENV
        
        const travelApi = axios.create({
            baseURL: APP_ENV === 'development' ? process.env.VUE_APP_API_URL_TRAVEL_DEV : process.env.VUE_APP_API_URL_TRAVEL
        })

        travelApi.interceptors.request.use(async (config) => {
            const system = store.getters['session/getSystem']
            config.params = {...config.params, system: system ?? undefined }
            var token = await localStorage.getItem('access_token')
            config.headers.Authorization = (token ? 'Bearer ' + token : null)
            return config
        }, function (error) {
            console.log('request reject', error)
            return Promise.reject(error)
        })

        travelApi.interceptors.response.use((response) => {
            return response.data ? response.data : response
        }, (error) => {
            if (error?.response?.status === 401 && error?.response?.data?.message === 'Unauthenticated.') {
                Cookies.remove('sessionToken', {
                    domain: '.acetours.sg',
                    path: '/'
                })
                localStorage.clear()

                window.location.href = '/login'
            }

            const { response = {} } = error
            const { data } = response
            return Promise.reject(data)
        })

        return travelApi
    }
}


export default TravelApi
